module.exports = __webpack_public_path__ + "images/videoCaseStudy-urbanPartnershipBank-og.jpg?h=e7fd8e378bccb4a764a79d8482de4642";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/videoCaseStudies/urbanPartnershipBank/videoCaseStudy-urbanPartnershipBank-og.jpg
// module id = 1722
// module chunks = 12 15